<template>
	<article :class="[componentClass, defaultColorMode, {visible: visible, ready: ready}]">
		<div :class="['covid-hero', {
			visible: heroVisible,
		}]">
			<div class="row">
				<div class="columns">
					<div class="circle-wrapper">
						<transition name="fade">
							<div>
								<h1 v-if="data.title_bold"><strong>{{ data.title_bold }}</strong> {{ data.title_regular }}</h1>
								<p v-if="data.text">{{ data.text }}</p>
							</div>
						</transition>
					</div>
				</div>
			</div>
			<div v-if="heroVisible && numberHearts" class="hearts-outer-wrapper">
				<div class="hearts-inner-wrapper">
				<div v-for="wrapperIndex in 2" :key="'hearts-wrapper-' + wrapperIndex" :class="['hearts-wrapper', {
					'offset-left': wrapperIndex===1,
					'offset-right': wrapperIndex!==1
				}]">
					<div v-for="index in numberHearts" :key="index" :class="['heart', {
						'': (
							(wrapperIndex === 1 && hearts.yellow.includes(index)) || 
							(wrapperIndex !== 1 && hearts.green.includes(index))
						),
						'': (
							(wrapperIndex === 1 && hearts.green.includes(index + 1)) || 
							(wrapperIndex !== 1 && hearts.yellow.includes(index + 1))
						),
					}]">
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="96" height="83" viewBox="0 0 96 83">
							<g fill-rule="evenodd">
								<path d="M337.857 2.363c-12.311-5.817-27.001-.526-32.8 11.825-.403.859-.752 1.935-1.06 3.184-.302-1.249-.652-2.325-1.055-3.184-5.803-12.35-20.485-17.642-32.8-11.825-12.307 5.816-17.586 20.54-11.787 32.889C264.155 47.602 303.991 83 303.991 83l.007-.114.01.114s39.837-35.397 45.636-47.748c5.799-12.349.527-27.073-11.787-32.889" transform="translate(-251 -406) translate(0 58) translate(-5 38) translate(0 310)"/>
							</g>
						</svg>
					</div>
				</div>
				</div>
			</div>
		</div>
		<div ref="sectionsWrapper" id="covid-sections-wrapper" :class="[sectionsBackgroundColor]">
			<section v-for="(section, sectionIndex) in data.sections" :key="section.component_id" :class="['section', 'section-covid', section.media.toLowerCase(), section.theme, {
				active: sectionIndex===activeIndex,
				visible: sectionIndex===activeIndex,
				'media-right' : section.media_location==='right',
				'media-left' : section.media_location!=='right', 
				'heart-title' : section.media==='VideoPlayer', 
				'light' : section.theme === 'dark-green',
				'dark' : section.theme !== 'dark-green'
			}]">
				<div :class="[mediaColumns]">
					<guy-with-glasses v-if="section.media==='GuyWithGlasses'" />
					<video-player v-if="section.media==='VideoPlayer'" v-on:initialized="updateOffsets" :data="section.video" />
					<ruter-map v-if="section.media==='Map'" v-on:initialized="updateOffsets" />
					<summer-chill v-if="section.media==='SummerChill'" />
					<girl-with-mask v-if="section.media==='GirlWithMask'" v-on:initialized="updateOffsets" />
					<photo-stack v-if="section.media==='PhotoStack'" :image="section.image" v-on:initialized="updateOffsets" />
					<footsteps v-if="section.media==='Footsteps'" @load="updateOffsets" />
				</div>
				<div ref="textColumn" :class="textColumns">
					<wysiwyg-content ref="textWrapper" 
						:data="section.wysiwyg_content" 
						:columns="2"></wysiwyg-content>
				</div>
			</section>
		</div>
	</article>
</template>

<script>
import BaseDynamicBlock from './BaseDynamicBlock'
import GuyWithGlasses from './covid-page/GuyWithGlasses'
import RuterMap from './covid-page/RuterMap'
import SummerChill from './covid-page/SummerChill'
import GirlWithMask from './covid-page/GirlWithMask'
import PhotoStack from './covid-page/PhotoStack'
import Footsteps from './covid-page/Footsteps'
export default {
	extends: BaseDynamicBlock,
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'covid-page',
			visible: true,
			hearts: {
				yellow: [1,4,6,10,11,13,16,21,23,24,35,36,38,20,44,46,50],
				green: [3,5,9,12,15,17,18,25,28,31,33,34,39,42,45,47,48,49]
			},
			mediaColumns:'media-column columns small-12 medium-5 xlarge-4 xlarge-offset-1',
			textColumns: 'text-column columns small-12 medium-7 xlarge-5 xlarge-offset-1',
			sectionTopOffsets: [],
			colorsByOffset: {},
			previousOffset: 0,
			nextOffset: 0,
			scrollTimeout: null,
			sectionsBackgroundColor: '',
			heroVisible: true,
			heroBreakpoint: 0,
			activeIndex: 0,
			numberHearts: 120
		}
	},
	components: {
		WysiwygContent: () => import('RuterSharedBlocks/wysiwyg/Content'),
		VideoPlayer: () => import('RuterSharedBlocks/media/content/VideoPlayer'),
		GuyWithGlasses,
		RuterMap,
		SummerChill,
		GirlWithMask,
		PhotoStack,
		Footsteps
	},
	methods: {
		updateOffsets() {
			let offsets = [];
			this.heroBreakpoint = window.innerHeight*1.5;
			let sections = this.$refs.sectionsWrapper.querySelectorAll('section.section-covid')
			for (let i = 0; i < sections.length; i++) {
				let sectionTopOffset = this.$refs.sectionsWrapper.offsetTop + sections[i].offsetTop;
				offsets.push(sectionTopOffset)
			}
			offsets.push(document.documentElement.scrollHeight);
			this.sectionTopOffsets = offsets;
		},
		handleScroll() {
			let previous = 0;
			let next = 0;
			let currentIndex = 0;
			for (let i = 0; i < this.sectionTopOffsets.length; i++) {
				if (window.scrollY>this.sectionTopOffsets[i]) {
					previous = this.sectionTopOffsets[i];
					next = this.sectionTopOffsets[i+1];
					currentIndex = i;
				}
			}
			this.previousOffset = previous;
			this.nextOffset = next;

			const colorTheme = (typeof this.data.sections[currentIndex] !== 'undefined') ? this.data.sections[currentIndex].theme : false;
			const colorMode = (colorTheme==='dark-green') ? 'dark' : 'light';

			if (colorMode==='dark') {
				document.body.classList.add('force-light-article-menu')
			} else {
				document.body.classList.remove('force-light-article-menu')
			}

			this.heroVisible = window.scrollY<this.heroBreakpoint;
		},
		initCovidPage() {
			window.setTimeout(() => {
				this.updateOffsets();
			}, 2500);
			this.sectionsBackgroundColor = this.data.sections[0].theme;
			window.addEventListener('scroll', this.handleScroll);
			window.addEventListener('resize', this.updateOffsets);
		},
		destroyCovidPage() {
			window.removeEventListener('scroll', this.handleScroll);
			window.removeEventListener('resize', this.updateOffsets);
		}
	},
	mounted() {
		this.initCovidPage();
	},
	destroy() {
		this.destoryCovidPage();
	},
	watch: {
		previousOffset(newValue) {
			let index = 0;
			for (let i = 0; i < this.sectionTopOffsets.length; i++) {
				if (newValue===this.sectionTopOffsets[i]) {
					index = i;
				}
			}
			if (typeof this.data.sections[index] === 'undefined') return;
			this.activeIndex = index;
			this.sectionsBackgroundColor = this.data.sections[this.activeIndex].theme;
		},
	}
}
</script>

<style lang="scss">
@import "@/styles/scss/component/_covid-page";
</style>